/*
 * @Author: cryi.liu
 * @Date: 2020-05-12 09:30:10
 * @LastEditTime: 2020-05-12 09:31:02
 * @Description: write you description
 */
import http from '../http';

const Plugin = {
  install(Vue, name = '$http') {
    Object.defineProperty(Vue.prototype, name, { value: http });
  },
};

export default Plugin;
